import { render, staticRenderFns } from "./AlterarDadosLocal.vue?vue&type=template&id=4b2b8cdc&scoped=true"
import script from "./AlterarDadosLocal.vue?vue&type=script&lang=js"
export * from "./AlterarDadosLocal.vue?vue&type=script&lang=js"
import style0 from "./AlterarDadosLocal.vue?vue&type=style&index=0&id=4b2b8cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2b8cdc",
  null
  
)

export default component.exports